import { createEvent } from 'effector';

export const putBlockedBucketsEv = createEvent();

export const resetBlockedBucketsEv = createEvent();

export const putThresholdsEv = createEvent();

export const calculateThresholdsEv = createEvent();

export const calculateDistThresholdsEv = createEvent();

export const calculateHexThresholdsEv = createEvent();

export const changeBucketAlgorithmEv = createEvent();
